module.exports = __webpack_public_path__ + "img/serviceicon3.3bc54f1f.gif";